// frontend/src/components/UnsubscribeForm.jsx
// Role: Email unsubscribe form component with input field and unsubscribe button

import React, { useState } from 'react';
import './SubscriptionForm.css'; // Reuse existing styles

function UnsubscribeForm({ onUnsubscribe }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setMessage('Please enter your email address');
      setMessageType('error');
      return;
    }

    setLoading(true);
    setMessage('');
    
    try {
      const result = await onUnsubscribe(email);
      
      if (result.success) {
        setMessage('Successfully unsubscribed! You will no longer receive emails.');
        setMessageType('success');
        setEmail(''); // Clear the input
      } else {
        setMessage(result.message || 'Unsubscribe failed. Please try again.');
        setMessageType('error');
      }
    } catch (error) {
      setMessage('Network error. Please try again.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscription-form">
      <div className="subscription-header">
        <h3>📧 Unsubscribe from Daily Stock News</h3>
        <p>Enter your email address to stop receiving daily stock news</p>
      </div>
      
      <form onSubmit={handleSubmit} className="subscription-form-container">
        <div className="input-group">
          <input
            type="email"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="email-input"
            disabled={loading}
            required
          />
          <button 
            type="submit" 
            className="subscribe-button unsubscribe-button"
            disabled={loading}
          >
            {loading ? 'Unsubscribing...' : 'Unsubscribe'}
          </button>
        </div>
        
        {message && (
          <div className={`message ${messageType}`}>
            {message}
          </div>
        )}
      </form>
    </div>
  );
}

export default UnsubscribeForm;